import React from 'react';

const Additional = () => {
  const menuItems = [
    {
      id: 1,
      name: 'Nitsuh Yetef Enjera || Teff Sourdough Crepes',
      description: 'Injera is a sour fermented pancake-like flatbread with a slightly spongy texture',
      image: '/enjera.jpeg', // Replace with the actual image URL
    },
    {
      id: 2,
      name: 'Difo Dabo || Ethiopian Bread ',
      description: 'Difo Dabo is a traditional Ethiopian bread of wheat flour, spices, oil, and sugar that’s baked in a pan.',
      
      image: '/dabo.jpg', // Replace with the actual image URL
    },
    {
        id: 3,
        name: 'Ambasha || Ethiopian Ambasha (Flat Bread) ',
        description: 'The dough is given a decorative touch before baking. The design varies in detail, but in general, is given the shape of a wheel with indentations to create several spokes.',
       
        image: '/ambasha.jpg', // Replace with the actual image URL
      },
      
  ];

  return (
    <div className=" py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-semibold text-center mb-8">Additional</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="bg-amber-400 rounded-lg p-6 shadow-lg transition-transform transform hover:scale-105"
            >
              <img
                src={item.image}
                alt={item.name}
                className="w-full h-auto object-cover mb-4 rounded"
              />
              <h3 className="text-xl text-center font-semibold mb-2">{item.name}</h3>
              <p className="text-gray-600 text-center mb-4">{item.description}</p>
           
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Additional;
